export default __webpack_public_path__ + "static/media/yaroslavl_bazarov.cc9f9f54.jpg";